import { render, staticRenderFns } from "./FormValidates.vue?vue&type=template&id=86fde4ee"
import script from "./FormValidates.vue?vue&type=script&lang=js"
export * from "./FormValidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports